import React, { Component } from "react"
import { withStyles, Typography, Divider } from "@material-ui/core"
import GeneralTable from "../../Shared/GeneralTable"
import AddElementButton from "../../Shared/AddElementButton"
import autobind from "../../Utils/autobind"
import { createBranchAction } from "../../Actions/BranchActions"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { ExitToApp } from "@material-ui/icons"
import { withRouter } from "react-router-dom"
import GeneralForm from "../../Shared/GeneralForm"
import { branchInfo } from "./Info"
import FormContext from "../../Shared/Cards/Provider"
import { getBranches } from "../../Actions/EnterpriseAction"
import LoaderAnimator from "../../Shared/LoaderAnimator"

const style = () => ({
    container: {
        padding: 12,
    },
    title: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    formContainer: {
        overflowY: "hidden",
        transition: "all 0.2s linear",
    },
    info: {
        width: "100%",
        maxWidth: 200,
        display: "block",
        marginRight: 24,
        "@media (max-width:500px)": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: "unset",
            marginRight: 0,
        },
    },
    input: {
        margin: "12px 0 ",
    },
    button: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 12,
        alignItems: "center",
    },
    flex: {
        display: "flex",
        flexWrap: "wrap",
    },
})

const tableInfo = [
    { name: "Nombre", label: "name" },
    { name: "Dirección", label: "address" },
]

class Branches extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            params: {},
            loading: true
        }
        autobind(Branches, this)
    }

    componentDidMount() {
        const { getBranches } = this.props
        getBranches().then(() => this.setState({ loading: false }))
    }

    handleChange(event) {
        const { target } = event
        const { params } = this.state
        params[target.name] = target.value
        this.setState({ params })
    }

    handleGoto(row) {
        return () => {
            const { history } = this.props
            history.push(`/branches/${row.id}`)
        }
    }

    handleOpen() {
        this.setState({ open: !this.state.open })
    }

    handleSend() {
        const { createBranch, enqueueSnackbar } = this.props
        const { params } = this.state
        const body = { ...params }
        body.companyId = 4
        createBranch(body, enqueueSnackbar)
        this.setState({ open: false, params: {} })
    }

    render() {
        const { open, params, loading } = this.state
        const { classes, user, enterprise } = this.props
        const branches = enterprise.branches || []
        const level = user.account.user.userType
        const actions = level === 1 ? [
            { name: "Ver centro de trabajo", icon: ExitToApp, action: this.handleGoto, color: "primary" },
        ] : []
        return (
            <div className={classes.container}>
                <div className={classes.title}>
                    <Typography variant="h1">
                        Centros de trabajo
                    </Typography>
                    {level === 1 && <AddElementButton name="Agregar centro" onClick={this.handleOpen} open={open} />}
                </div>
                <FormContext.Provider value={{ handleChange: this.handleChange, params }}>
                    <GeneralForm
                        open={open}
                        info={branchInfo}
                        onSubmit={this.handleSend}
                        submit="Crear Centro"
                        title="Nueva centro de trabajo"
                    />
                </FormContext.Provider>
                <Divider style={{ marginBottom: 24 }} />
                {loading ?
                    <LoaderAnimator loading />
                    :
                    <GeneralTable
                        data={branches}
                        info={tableInfo}
                        actions={actions}
                    />
                }
            </div>
        )
    }
}

Branches.propTypes = {}

Branches.defaultProps = {
    branches: [],
}

const mapStateToProps = state => ({
    user: state.user,
    enterprise: state.enterprise
})

const mapDispatchToProps = (dispatch) => ({
    createBranch: (body, snackbar) => dispatch(createBranchAction(body, snackbar)),
    getBranches: (body) => dispatch(getBranches(body)),
})

export default withRouter(
    withSnackbar(connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(Branches)))
)
